var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2815 4.92409C17.6839 4.50409 18.2403 4.2666 18.8219 4.2666H46.9C48.0782 4.2666 49.0333 5.22173 49.0333 6.39994V57.5999C49.0333 58.7781 48.0782 59.7333 46.9 59.7333H10.6333C9.45513 59.7333 8.5 58.7781 8.5 57.5999V14.947C8.5 14.397 8.7124 13.8682 9.09288 13.4711L17.2815 4.92409ZM46.9 6.39994H18.8219L10.6333 14.947V57.5999H46.9V6.39994Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5026 4.86441C18.5105 3.85647 20.234 4.57034 20.234 5.99579V13.8664C20.234 14.75 19.5176 15.4664 18.634 15.4664H10.7634C9.33792 15.4664 8.62405 13.743 9.63199 12.735L17.5026 4.86441Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1006 7.28337L12.0509 13.333H18.1006V7.28337ZM20.234 5.99579C20.234 4.57034 18.5105 3.85647 17.5026 4.86441L9.63199 12.735C8.62405 13.743 9.33792 15.4664 10.7634 15.4664H18.634C19.5176 15.4664 20.234 14.75 20.234 13.8664V5.99579Z",
    fill: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4336 11.7338C23.4336 10.8501 24.1499 10.1338 25.0336 10.1338H41.0336C41.9173 10.1338 42.6336 10.8501 42.6336 11.7338C42.6336 12.6174 41.9173 13.3338 41.0336 13.3338H25.0336C24.1499 13.3338 23.4336 12.6174 23.4336 11.7338Z",
    fill: "#E5E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9004 19.7337C14.9004 19.1446 15.378 18.667 15.9671 18.667H41.5671C42.1562 18.667 42.6337 19.1446 42.6337 19.7337C42.6337 20.3228 42.1562 20.8003 41.5671 20.8003H15.9671C15.378 20.8003 14.9004 20.3228 14.9004 19.7337Z",
    fill: "#E5E5E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9004 24.0003C14.9004 23.4112 15.378 22.9336 15.9671 22.9336H41.5671C42.1562 22.9336 42.6337 23.4112 42.6337 24.0003C42.6337 24.5894 42.1562 25.0669 41.5671 25.0669H15.9671C15.378 25.0669 14.9004 24.5894 14.9004 24.0003Z",
    fill: "#E5E5E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9004 43.2005C14.9004 42.6114 15.378 42.1338 15.9671 42.1338H41.5671C42.1562 42.1338 42.6337 42.6114 42.6337 43.2005C42.6337 43.7896 42.1562 44.2671 41.5671 44.2671H15.9671C15.378 44.2671 14.9004 43.7896 14.9004 43.2005Z",
    fill: "#E5E5E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9004 47.4671C14.9004 46.878 15.378 46.4004 15.9671 46.4004H41.5671C42.1562 46.4004 42.6337 46.878 42.6337 47.4671C42.6337 48.0562 42.1562 48.5337 41.5671 48.5337H15.9671C15.378 48.5337 14.9004 48.0562 14.9004 47.4671Z",
    fill: "#E5E5E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9004 51.7337C14.9004 51.1446 15.378 50.667 15.9671 50.667H29.8337C30.4228 50.667 30.9004 51.1446 30.9004 51.7337C30.9004 52.3228 30.4228 52.8003 29.8337 52.8003H15.9671C15.378 52.8003 14.9004 52.3228 14.9004 51.7337Z",
    fill: "#E5E5E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9004 29.8666C14.9004 28.9829 15.6167 28.2666 16.5004 28.2666H41.0337C41.9174 28.2666 42.6337 28.9829 42.6337 29.8666V37.3333C42.6337 38.2169 41.9174 38.9333 41.0337 38.9333H16.5004C15.6167 38.9333 14.9004 38.2169 14.9004 37.3333V29.8666Z",
    fill: "#F5F5F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0337 30.3999V36.7999H40.5004V30.3999H17.0337ZM16.5004 28.2666C15.6167 28.2666 14.9004 28.9829 14.9004 29.8666V37.3333C14.9004 38.2169 15.6167 38.9333 16.5004 38.9333H41.0337C41.9174 38.9333 42.6337 38.2169 42.6337 37.3333V29.8666C42.6337 28.9829 41.9174 28.2666 41.0337 28.2666H16.5004Z",
    fill: "#E5E5E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0332 55.4665H50.6332C51.8114 55.4665 52.7665 54.5114 52.7665 53.3332V10.6665C52.7665 9.48833 51.8114 8.5332 50.6332 8.5332H49.0332V10.6665H50.6332V53.3332H49.0332V55.4665Z",
    fill: "#E5E5E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7676 52.2667H54.3676C55.5458 52.2667 56.5009 51.498 56.5009 50.5497V13.4505C56.5009 12.5022 55.5458 11.7334 54.3676 11.7334H52.7676V13.4505H54.3676V50.5497H52.7676V52.2667Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyDocuments);
export default __webpack_public_path__ + "static/media/company_documents.d199d8a99cb1c8f654ff4a6e935520c6.svg";
export { ForwardRef as ReactComponent };